import type { SourceId } from "./ids.ts";

export type MediaKind = "image" | "audio" | "video";

type SourceBase = {
  readonly id: SourceId;
  readonly name: string;
  readonly mimeType: string;
  readonly sizeBytes: number;
  /** ISO 8601 in UTC. */
  readonly importedAt: string;
};

export type ImageSource = SourceBase & {
  readonly kind: "image";
  readonly widthPx: number;
  readonly heightPx: number;
  /** Absent on projects imported before these were recorded; shown as unknown. */
  readonly bitDepth?: number;
  readonly hasAlpha?: boolean;
  readonly usesTransparency?: boolean;
};

export type AudioSource = SourceBase & {
  readonly kind: "audio";
  readonly durationSec: number;
  readonly sampleRateHz: number;
  readonly channelCount: number;
};

export type VideoSource = SourceBase & {
  readonly kind: "video";
  readonly durationSec: number;
  readonly widthPx: number;
  readonly heightPx: number;
  readonly frameRate: number;
  readonly hasAudio: boolean;
};

export type Source = ImageSource | AudioSource | VideoSource;

/** A still has no intrinsic duration; on a timeline its length comes from the clip. */
export function sourceDurationSec(source: Source): number {
  return source.kind === "image" ? 0 : source.durationSec;
}

export function sourcePixelSize(source: Source): { widthPx: number; heightPx: number } | null {
  return source.kind === "audio" ? null : { widthPx: source.widthPx, heightPx: source.heightPx };
}
